module.exports = __webpack_public_path__ + "static/Erewhon_pin-3c5d7ef2ac291970640931e7494bee80.png";